import { useNotices } from 'hooks';

import Modal from 'components/common/Modal';

import * as S from './styles';

interface IModalCopyToClipboardProps {
  setShowModalCopyToClipboard(state: boolean): void;
}

export function ModalCopyToClipboard({
  setShowModalCopyToClipboard,
}: IModalCopyToClipboardProps) {
  const { addNotices } = useNotices();

  function copyToClipboard() {
    if (navigator.clipboard && window.isSecureContext) {
      // Usa a API clipboard moderna
      try {
        navigator.clipboard.writeText(window.location.href);

        addNotices({
          type: 'success',
          messages: ['Link copiado para a área de transferência!'],
        });
      } catch (err) {
        addNotices({
          type: 'errors',
          messages: ['Erro ao copiar link para área de transferência.'],
        });
      }
    } else {
      // Fallback para navegadores mais antigos
      try {
        const textArea = document.createElement('textarea');
        textArea.value = window.location.href;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);

        addNotices({
          type: 'success',
          messages: ['Link copiado para a área de transferência!'],
        });
      } catch (err) {
        addNotices({
          type: 'errors',
          messages: ['Erro ao copiar link para área de transferência.'],
        });
      }
    }
  }

  return (
    <S.Container className="modal-copy-to-clipboard">
      <Modal onClose={() => setShowModalCopyToClipboard(false)}>
        <h4>Compartilhar</h4>

        <span className="modal-copy-to-clipboard-message">
          Copie o link abaixo para compartilhar:
        </span>

        <div className="modal-copy-to-clipboard-link">
          <span>{window.location.href}</span>
          <button
            className="modal-button"
            onClick={() => {
              setShowModalCopyToClipboard(false);
              copyToClipboard();
            }}
          >
            Copiar
          </button>
        </div>
      </Modal>
    </S.Container>
  );
}
